import request from '@/utils/request'
 
export function getItem(data) {
  return request({
    url: '/student/Get',
    method: 'post',
    data: { id: data },
  })
}
 
export function fetchList(data) {
  return request({
    url: '/student/List',
    method: 'post',
    data,
  })
}

export function fetchStudentProfileList(data) {
  return request({
    url: '/student/Coach_StudentProfileList',
    method: 'post',
    data,
  })
}


 

export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/student/Create',
    method: 'post',
    data,  
     headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
  )
}


export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/student/update',
    method: 'post',
    data,  
     headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function deleteItem(data) {
  return request({
    url: '/student/Delete',
    method: 'delete',
    data,
  })
}

